/**
 * AEON Predictive UX: Hover-Intent Speculation
 * Inyecta Speculation Rules dinámicas basadas en la intención de navegación del usuario.
 */

const PREFETCH_THRESHOLD = 65; // ms de hover para considerar intención real
const activePrefetches = new Set();

export const initPredictive = () => {
    // 1. Verificar soporte de Speculation Rules API
    const supportsSpeculation = HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');
    
    if (!supportsSpeculation) {
        console.debug('[Predictive] Speculation Rules not supported. Falling back to standard prefetch.');
        // Opcional: Implementar fallback con <link rel="prefetch">
        return;
    }

    console.debug('⚡ [Predictive] Hover-Intent engine active (Threshold: 65ms).');

    document.addEventListener('mouseover', (e) => {
        const link = e.target.closest('a');
        if (!link || !link.href) return;

        // Solo enlaces internos
        if (!link.href.startsWith(window.location.origin)) return;
        
        // Evitar duplicados o la página actual
        const url = link.href.split('#')[0];
        if (url === window.location.href.split('#')[0] || activePrefetches.has(url)) return;

        let hoverTimer = setTimeout(() => {
            injectSpeculationRule(url);
        }, PREFETCH_THRESHOLD);

        link.addEventListener('mouseout', () => clearTimeout(hoverTimer), { once: true });
    }, { passive: true });
};

const injectSpeculationRule = (url) => {
    if (activePrefetches.has(url)) return;
    activePrefetches.add(url);

    console.debug(`🔮 [Predictive] Speculating intent for: ${url}`);

    const specScript = document.createElement('script');
    specScript.type = 'speculationrules';
    const spec = {
        prefetch: [
            {
                source: 'list',
                urls: [url],
                requires: ['anonymous-client-ip-when-cross-origin']
            }
        ]
    };
    
    specScript.textContent = JSON.stringify(spec);
    document.head.appendChild(specScript);
};

export default { initPredictive };
